import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bars-white",
  "use": "bars-white-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bars-white\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><rect x=\"6\" y=\"8\" width=\"20\" height=\"2\" rx=\"1\" /><rect x=\"6\" y=\"15\" width=\"20\" height=\"2\" rx=\"1\" /><rect x=\"6\" y=\"22\" width=\"20\" height=\"2\" rx=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol